const ALL_FIELDS = {
  STATUS: 'Status',
  IMPACT: 'Impact',
  URGENCY: 'Urgency',
  PRIORITY: 'Priority',
  TICKET_TYPE: 'TicketType',
  CAUSE: 'Cause',
  CATEGORY: 'Category',
  RESOLUTION_CODE: 'ResolutionCode',
  TEXT: 'TEXT',
  PARAGRAPH: 'PARAGRAPH',
  NUMERIC: 'NUMERIC',
  DECIMAL: 'DECIMAL',
  DATE: 'DATE',
  DATETIME: 'DATETIME',
  RADIO: 'RADIO',
  CHECKBOX: 'CHECKBOX',
  SELECT: 'SELECT',
  MULTI_SELECT: 'MULTI_SELECT'
};

const CUSTOM_FIELDS_TYPE = {
  TEXT: 'TEXT',
  PARAGRAPH: 'PARAGRAPH',
  NUMERIC: 'NUMERIC',
  DECIMAL: 'DECIMAL',
  DATE: 'DATE',
  DATETIME: 'DATETIME',
  RADIO: 'RADIO',
  CHECKBOX: 'CHECKBOX',
  SELECT: 'SELECT',
  MULTI_SELECT: 'MULTI_SELECT',
  SECURE_TEXT: 'SECURE_TEXT'
};

const DEFAULT_FIELDS_BY_COLUMN_NAME = {
  STATUS: 'status',
  IMPACT: 'impact',
  URGENCY: 'urgency',
  PRIORITY: 'priority',
  TICKET_TYPE: 'ticketType',
  CAUSE: 'cause',
  CATEGORY: 'category',
  RESOLUTION_CODE: 'resolutionCode',
  SUB_CAUSE: 'subcause',
  SUB_CATEGORY: 'subcategory',
  PAYMENT_TERMS: 'paymentTerms',
  PAYMENT_METHOD: 'paymentMethod'
};

const DEFAULT_CLIENT_FIELDS_BY_COLUMN_NAME = {
  STAGE: 'stage',
  STATUS: 'status'
};

const DEFAULT_FIELDS_TRANSLATED_LABEL = {
  [DEFAULT_FIELDS_BY_COLUMN_NAME.STATUS]: 'entity.status',
  [DEFAULT_FIELDS_BY_COLUMN_NAME.IMPACT]: 'entity.impact',
  [DEFAULT_FIELDS_BY_COLUMN_NAME.URGENCY]: 'entity.urgency',
  [DEFAULT_FIELDS_BY_COLUMN_NAME.PRIORITY]: 'entity.priority',
  [DEFAULT_FIELDS_BY_COLUMN_NAME.TICKET_TYPE]: 'admin.defaultField.ticketType',
  [DEFAULT_FIELDS_BY_COLUMN_NAME.CAUSE]: 'entity.cause',
  [DEFAULT_FIELDS_BY_COLUMN_NAME.CATEGORY]: 'entity.category',
  [DEFAULT_FIELDS_BY_COLUMN_NAME.RESOLUTION_CODE]:
    'role.feature.resolutionCode',
  [DEFAULT_FIELDS_BY_COLUMN_NAME.SUB_CAUSE]: 'entity.subCause',
  [DEFAULT_FIELDS_BY_COLUMN_NAME.SUB_CATEGORY]: 'entity.subCategory',
  [DEFAULT_FIELDS_BY_COLUMN_NAME.PAYMENT_TERMS]:
    'client.invoice.settings.paymentTerm.title',
  [DEFAULT_FIELDS_BY_COLUMN_NAME.PAYMENT_METHOD]:
    'client.invoice.settings.paymentMethod.title',
  [DEFAULT_CLIENT_FIELDS_BY_COLUMN_NAME.STAGE]: 'attribute.stage',
  [DEFAULT_CLIENT_FIELDS_BY_COLUMN_NAME.STATUS]: 'entity.status'
};

const DEPENDENT_FIELD_MAP = {
  SUB_CAUSE: 'subcause',
  SUB_CATEGORY: 'subcategory'
};

const DEPENDENT_FIELD_LABEL = {
  SUB_CAUSE: 'attribute.subcause',
  SUB_CATEGORY: 'admin.CategorySubCategory.subcategory'
};

const FIELD_CATEGORY = {
  DEFAULT: 'DEFAULT',
  CUSTOM: 'CUSTOM'
};

export {
  ALL_FIELDS,
  CUSTOM_FIELDS_TYPE,
  DEFAULT_FIELDS_BY_COLUMN_NAME,
  DEPENDENT_FIELD_MAP,
  DEPENDENT_FIELD_LABEL,
  FIELD_CATEGORY,
  DEFAULT_CLIENT_FIELDS_BY_COLUMN_NAME,
  DEFAULT_FIELDS_TRANSLATED_LABEL
};
